var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2892 14.5L9.20238 8.82746C8.92723 8.63449 8.93342 8.32585 9.21619 8.1381C9.49895 7.95034 9.95114 7.95457 10.2262 8.14754L18.7976 14.1601C19.0675 14.3493 19.0675 14.6507 18.7976 14.84L10.2262 20.8525C9.95114 21.0454 9.49895 21.0497 9.21619 20.8619C8.93342 20.6742 8.92723 20.3655 9.20238 20.1726L17.2892 14.5Z",
    fill: "#13559F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    stroke: "#4174B8",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.eb07fbe5f5ea1fd7a5bb88aca392009e.svg";
export { ForwardRef as ReactComponent };